import type { RootData } from '~/root';
import { useRouteLoaderData } from 'react-router';

export const useRootData = (): RootData => {
    return useRouteLoaderData('root') as RootData;
};
